import React from 'react';
export default function Em(props) {
    return React.createElement("em", null, props.children);
}
//# sourceMappingURL=em.js.map